module.exports = __webpack_public_path__ + "static/media/logo.ac151782.png";